import React, { Fragment, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect, useLocation, useHistory } from "react-router-dom"
import anzyz_logo from "../images/logo-anzyz.png"

import "../css/login.css"
//import anzyz_legal_logo from '../images/logo_legal_anzyz.png';

//Redux actions
import { showAlertAction, hideAlertAction, alertActions, newHideAlert } from "../actions/alertActions"
import {
	loginAzure,
	startingAzuleLogin,
	requestUser,
	azureAdGetLoginUrl,
	azureAdGetLoginUrlFailedClear,
	azureAdLoginRequest,
	redirectToHome,
	resetPasswordFailure,
} from "../actions/userActions"

import { loginRequest } from "../config/authConfig"
import { AzureSigninButton } from "../components/login/AzureSigninButton"
import { useIsAuthenticated, useMsal, MsalAuthenticationTemplate, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react"
import { InteractionType } from "@azure/msal-browser"
import { dispatch } from "d3-dispatch"

import { PublicClientApplication } from "@azure/msal-browser"

import { msalConfig } from "../config/authConfig"
import { MultiBaseDropdown } from "../components"
import { ROUTES } from "../utils"
import axios from "axios"
import { setNotification } from "../actions/notificationActions"
import Notification from "../components/Notification/Notification"

const msalInstance = new PublicClientApplication(msalConfig)

// Render JSON data in readable format
const PrettyPrintJson = ({ data }) => {
	return (
		<div>
			<pre>{JSON.stringify(data, null, 2)}</pre>
		</div>
	)
}
function ErrorComponent({ error }) {
	return <p>An Error Occurred: {error}</p>
}

const LoadingComponent = () => {
	return <p>Authentication in progress...</p>
}

const PageLoginNew = () => {
	const history = useHistory()
	const location = useLocation()

	/* ******************* REDUX STORE ******************* */
	const dispatch = useDispatch()
	let query = useQuery()
	//Access store state
	const alert = useSelector((state) => state.alert.alert)
	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	const user_token = useSelector((state) => state.authtentication.user)
	const startingLoggin = useSelector((state) => state.authtentication.isLoginInStart)
	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)
	const multibaseToken = useSelector((state) => state.multiBase.token)
	const selectedBase = useSelector((state) => state.multiBase.selectedBase)
	const azureAdLoginUrl = useSelector((state) => state.authtentication.azureAdLoginUrl)
	const users = useSelector((state) => state.users)

	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	//Component states
	const [username, setUsername] = useState("") // default_test_email: tester@test.com
	const [password, setPassword] = useState("") // default_test_password: testergo
	// eslint-disable-next-line
	const [submited, setSubmited] = useState(false)
	const [logged, setLogged] = useState(false)
	const [logPopupOpen, setLogPopupOpen] = useState(false)
	const [sendingAzureLogin, setSendingAzureLogin] = useState(false)
	const [showPassword, setShowPassword] = useState(false)
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	const anzyz_legal_logo = window._env_.REACT_APP_DASHBOARD_LOGO || anzyz_logo
	useEffect(() => {
		if (isUserLogedInt) {
			setLogged(true)
		}
	}, [isUserLogedInt])

	useEffect(() => {
		setSendingAzureLogin(startingLoggin)
	}, [startingLoggin])

	useEffect(() => {
		const isUISingleBase = multiBaseList.length === 1
		const isBaseSelected = Object.keys(selectedBase).length !== 0
		if (isUserLogedInt && (isUISingleBase || isBaseSelected)) {
			defaultRedirect()
		}

		if (query.get("code")) {
			const payload = {
				code: query.get("code"),
			}

			dispatch(azureAdLoginRequest(payload))
		}
	}, [])

	//on AI base selection
	useEffect(() => {
		if (multibaseToken) {
			defaultRedirect()
		}
	}, [multibaseToken])

	useEffect(() => {
		if (azureAdLoginUrl) {
			dispatch(azureAdGetLoginUrlFailedClear())
			window.location.href = azureAdLoginUrl //redirect user to azure login url
		}
	}, [azureAdLoginUrl])

	/*useEffect(() => {
        if (location.get("code")) {
            const payload = {
                code: location.get("code"),
                session: localStorage.getItem("azure")
            }

            dispatch(azureAdLoginRequest(payload))
        }
    }, [location])*/

	const defaultRedirect = () => {
		if (query.get("downloads")) {
			history.push(`${ROUTES.DOWNLOADS}/?downloads=${query.get("downloads")}`)
		} else {
			history.push(ROUTES.DASHBOARD)
		}
	}

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const submitLogin = (e) => {
		e.preventDefault()

		if (username.trim() === "" || password.trim() === "") {
			const alertLogin = {
				msg: "Please fill username and password",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alertLogin))
			return
		}
		// dispatch(hideAlertAction());
		// dispatch(login(username,password));
		dispatch(newHideAlert())
		dispatch(requestUser(username, password))
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	const isAuthenticated = useIsAuthenticated()
	const { instance, accounts } = useMsal()

	if (window._env_.REACT_APP_AUTH_TYPE === "MSOFT") {
		if (isAuthenticated && user_token === undefined && sendingAzureLogin === false) {
			try {
				dispatch(startingAzuleLogin(true))
				setSendingAzureLogin(true)
				//dispatch(loginAzure(accounts[0].idTokenClaims.oid));
				dispatch(loginAzure(accounts[0].idTokenClaims.oid, accounts[0].name, accounts[0].username))
			} catch (e) {}
		}
	}

	const authRequest = {
		scopes: ["openid", "profile"],
	}

	const forgotPassword = () => {
		history.push(ROUTES.FORGOT_PASSWORD)
	}
	const startLogin = async (e) => {
		e.preventDefault()

		try {
			const loginResponse = msalInstance.loginPopup(authRequest)

			//const username = (await loginResponse).account.username;
			//const token = (await loginResponse).accessToken;
			const oid = (await loginResponse).account
			/*
            environment: "login.windows.net"
  homeAccountId: "81e489b6-b087-4cd6-9f45-b98c55ae6485.9b6353ff-954a-4769-ada2-44b0e3e346c9"
  idTokenClaims: {aud: 'f5d41c30-5caf-4a27-97b9-26b6e79dd5d4', iss: 'https://login.microsoftonline.com/9b6353ff-954a-4769-ada2-44b0e3e346c9/v2.0', iat: 1646635401, nbf: 1646635401, exp: 1646639301, …}
  localAccountId: "81e489b6-b087-4cd6-9f45-b98c55ae6485"
  name: "Alejandro Hiniesta"
  tenantId: "9b6353ff-954a-4769-ada2-44b0e3e346c9"
  username: "Alejandro@anzyz.com"
            
            */
			//const oid=(await loginResponse).account.idTokenClaims.oid;
			//dispatch(loginAzure(oid));
			dispatch(loginAzure(oid.idTokenClaims.oid, oid.name, oid.username))
		} catch (err) {
			dispatch(
				alertActions.showAlertAction({
					msg: "There was a error with your Login, please try again.",
					class: "alert alert-danger",
				})
			)
		}
	}

	// try {
	// 	const backgroundImg = window._env_.REACT_APP_BACKGROUND
	// 	document.body.style.backgroundImage = "url('" + backgroundImg + "')"
	// 	document.body.classList.add("newLoginPage")
	// } catch (e) {}

	const getAzureAdLoginURL = async (e) => {
		e.preventDefault()
		dispatch(azureAdGetLoginUrl())
	}

	useEffect(() => {
		const backgroundImg = window._env_.REACT_APP_BACKGROUND
		document.body.style.backgroundImage = "url('" + backgroundImg + "')"
		document.body.classList.add("newLoginPage")
		localStorage.removeItem("user")
		return () => {
			document.body.style.backgroundImage = "none"
			document.body.classList.remove("newLoginPage")
		}
	}, [])

	useEffect(() => {
		if (users?.redirectToHome) {
			const fromPage = history.location.state?.from
			if (fromPage === "forgotPassword") {
				if (users?.resetPasswordError) {
					dispatch(
						setNotification({
							data: users?.resetPasswordError,
							severity: "error",
							duration: 3000,
						})
					)
					dispatch(resetPasswordFailure(null))
					dispatch(redirectToHome(false))
				} else {
					dispatch(
						setNotification({
							data: "You will receive a link to reset your password in email. Contact Anzyz Support in case you do not receive any email.",
							severity: "success",
							duration: 3000,
						})
					)
					dispatch(redirectToHome(false))
				}
			} else if (fromPage === "resetPassword") {
				if (users?.resetPasswordError) {
					dispatch(
						setNotification({
							data: users?.resetPasswordError,
							severity: "error",
							duration: 3000,
						})
					)
					dispatch(resetPasswordFailure(null))
				} else {
					dispatch(
						setNotification({
							data: "You have successfully reset your password. Please login with the new password.",
							severity: "success",
							duration: 3000,
						})
					)
				}
				dispatch(redirectToHome(false))
			}
		}
	}, [])

	return (
		<Fragment>
			<Notification />
			<div className="wrapper bg-white">
				<div className="h2 text-center">
					<img src={anzyz_legal_logo} width="100%" height="auto" alt=" " className="logo_producto" />
				</div>

				{window._env_.REACT_APP_AUTH_TYPE === "SELF" ? (
					<Fragment>
						<div className="h4 text-muted text-center pt-2">Enter your login details</div>
						<form className="pt-3" onSubmit={submitLogin}>
							<div className="form-group py-2">
								<div className="input-field">
									{" "}
									<span className="far fa-user p-2"></span>{" "}
									<input
										type="text"
										placeholder="Email"
										required
										className="qa-username"
										value={username}
										onChange={(e) => setUsername(e.target.value)}
										data-testid="username"
										data-cy="username_input"
									/>{" "}
								</div>
							</div>
							<div className="form-group py-1 pb-2">
								<div className="input-field">
									{" "}
									<span className="fas fa-lock p-2"></span>{" "}
									<input
										type={showPassword ? "text" : "password"}
										placeholder="Enter your Password"
										required
										className="qa-password"
										value={password}
										data-testid="password"
										data-cy="password_input"
										onChange={(e) => setPassword(e.target.value)}
									/>{" "}
									<a
										className="btn bg-white text-muted"
										onClick={(e) => {
											e.preventDefault()
											setShowPassword(!showPassword)
										}}
									>
										{" "}
										<span className={showPassword ? "far fa-eye-slash" : "far fa-eye"}></span>{" "}
									</a>{" "}
								</div>
							</div>
							<div className="d-flex align-items-start">
								<div className="remember"></div>
								<div className="pull-right forget-class forget-password">
									{" "}
									<a
										href="#"
										id="forgot"
										onClick={(e) => {
											e.preventDefault()
											forgotPassword()
										}}
									>
										Forgot Password?
									</a>
								</div>
							</div>
							{alert && alert.type !== "modal" ? (
								<div className="d-flex align-items-start">
									<p className={alert.class}>{alert.msg}</p>{" "}
								</div>
							) : null}
							<div className="d-flex align-items-start  my-3">
								{isUserLogedInt && multiBaseList.length > 1 ? (
									<MultiBaseDropdown />
								) : (
									<button
										className="btn btn-block text-center qa-login"
										data-testid="login_submit"
										data-cy="login_submit"
									>
										Log in
									</button>
								)}
							</div>
						</form>
					</Fragment>
				) : null}

				{window._env_.REACT_APP_AUTH_TYPE === "MSOFT" ? (
					<div>
						{/* <button className="btn btn-sm btn-outline-success my-2 my-sm-0 btn_login_azure" data-toggle="button" onClick={(e) => { startLogin(e) }}><i class="fab fa-microsoft"></i> Login with Azure AD</button> */}

						<div className="d-flex align-items-start justify-content-center my-3">
							{isUserLogedInt && multiBaseList.length > 1 ? (
								<div style={{ marginTop: "70px" }}>
									<MultiBaseDropdown />
								</div>
							) : (
								<button
									className="btn btn-sm btn-outline-success my-2 my-sm-0 btn_login_azure"
									data-toggle="button"
									onClick={(e) => {
										getAzureAdLoginURL(e)
									}}
								>
									<i className="fab fa-microsoft"></i> Login with Azure AD
								</button>
							)}
						</div>
					</div>
				) : null}
			</div>
		</Fragment>
	)
}
function useQuery() {
	const { search } = useLocation()

	return React.useMemo(() => new URLSearchParams(search), [search])
}

export default PageLoginNew
